/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { getTokenValidation } from '../api/auth/auth.requests';
import { STORAGE_KEYS } from '../constants';
import { getLocalStorageItem } from '../utils/storage';
import { getWindowStatus } from '../utils/window';

export const useTokenValidation = () => {
  const windowStatus = getWindowStatus();
  const queryClient = useQueryClient();
  const searchParams = useSearchParams();
  const urlParams = new URLSearchParams(searchParams.toString());
  const token = urlParams.get('code');
  const codeVerifier = windowStatus ? getLocalStorageItem(STORAGE_KEYS.AUTH_CODE_VERIFIER) : undefined;

  const getTokenValidationQuery = useQuery({
    queryKey: ['auth.token', token, codeVerifier],
    queryFn: () => {
      if (token && codeVerifier) {
        return getTokenValidation(token, codeVerifier);
      } else if (codeVerifier) {
        throw new Error('incomplete');
      } else {
        throw new Error('auth_error');
      }
    },
    enabled: !!token || !!codeVerifier,
  });

  useEffect(() => {
    if (!token) {
      void queryClient.resetQueries({ queryKey: ['auth.token'] });
    }
  }, [token, queryClient]);

  return getTokenValidationQuery;
};
